import { initializeLiveChat } from './fragments/live_chat.js';

document.addEventListener('DOMContentLoaded', () => {
  initializeLiveChat();
});
